/* tslint:disable */
/* eslint-disable */

/**
 * 401130000 = Textfeldeinzeilig (Textfeld einzeilig)
 * 
 * 401130001 = Textfeldmehrzeilig (Textfeld mehrzeilig)
 * 
 * 401130002 = Wahrung (Währung)
 * 
 * 401130003 = Datum (Datum)
 * 
 * 401130008 = GanzeZahl (Ganze Zahl)
 * 
 * 401130009 = Dezimalzahl (Dezimalzahl)
 * 
 * 401130004 = JaNein (Ja/Nein)
 * 
 * 401130005 = JaNeinmitBeschreibung (Ja/Nein mit Beschreibung)
 * 
 * 401130006 = JamitBeschreibung (Ja mit Beschreibung)
 * 
 * 401130007 = NeinmitBeschreibung (Nein mit Beschreibung)
 * 
 * 401130010 = Auswahl (Auswahl)
 * 
 * 401130011 = Mehrfachauswahl (Mehrfachauswahl)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAceFeldtyp {
 Textfeldeinzeilig = 401130000,
 Textfeldmehrzeilig = 401130001,
 Wahrung = 401130002,
 Datum = 401130003,
 GanzeZahl = 401130008,
 Dezimalzahl = 401130009,
 JaNein = 401130004,
 JaNeinmitBeschreibung = 401130005,
 JamitBeschreibung = 401130006,
 NeinmitBeschreibung = 401130007,
 Auswahl = 401130010,
 Mehrfachauswahl = 401130011
}

marker([
    "Enum.GlobalEnumsAceFeldtyp.Textfeldeinzeilig",
    "Enum.GlobalEnumsAceFeldtyp.Textfeldmehrzeilig",
    "Enum.GlobalEnumsAceFeldtyp.Wahrung",
    "Enum.GlobalEnumsAceFeldtyp.Datum",
    "Enum.GlobalEnumsAceFeldtyp.GanzeZahl",
    "Enum.GlobalEnumsAceFeldtyp.Dezimalzahl",
    "Enum.GlobalEnumsAceFeldtyp.JaNein",
    "Enum.GlobalEnumsAceFeldtyp.JaNeinmitBeschreibung",
    "Enum.GlobalEnumsAceFeldtyp.JamitBeschreibung",
    "Enum.GlobalEnumsAceFeldtyp.NeinmitBeschreibung",
    "Enum.GlobalEnumsAceFeldtyp.Auswahl",
    "Enum.GlobalEnumsAceFeldtyp.Mehrfachauswahl"
]);

export namespace GlobalEnumsAceFeldtyp
{
    class DataSets
    {
        static GlobalEnumsAceFeldtypDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Textfeldeinzeilig", 401130000, "Textfeld einzeilig"),
            new EnumValue("Textfeldmehrzeilig", 401130001, "Textfeld mehrzeilig"),
            new EnumValue("Wahrung", 401130002, "Währung"),
            new EnumValue("Datum", 401130003, "Datum"),
            new EnumValue("GanzeZahl", 401130008, "Ganze Zahl"),
            new EnumValue("Dezimalzahl", 401130009, "Dezimalzahl"),
            new EnumValue("JaNein", 401130004, "Ja/Nein"),
            new EnumValue("JaNeinmitBeschreibung", 401130005, "Ja/Nein mit Beschreibung"),
            new EnumValue("JamitBeschreibung", 401130006, "Ja mit Beschreibung"),
            new EnumValue("NeinmitBeschreibung", 401130007, "Nein mit Beschreibung"),
            new EnumValue("Auswahl", 401130010, "Auswahl"),
            new EnumValue("Mehrfachauswahl", 401130011, "Mehrfachauswahl"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAceFeldtypDataSet;
    }
}
